// src/router/guards/SuperAdminGuard.tsx
// Route guard — restricts access to ROLE_SUPER_ADMIN only.
import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '@/app/hooks'

export default function SuperAdminGuard() {
  const { user } = useAuth()

  const isSuperAdmin =
    user?.primaryRole?.includes('SUPER_ADMIN') ||
    user?.roles?.some((r) => r.includes('SUPER_ADMIN'))

  if (!isSuperAdmin) {
    return <Navigate to="/unauthorized" replace />
  }

  return <Outlet />
}
